import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { AccountLookupService } from "./AccountLookupService";
import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ITimezonePromiseLookupService } from "../ITimezonePromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { MarketTimeLookupService, IMarketTimePromiseLookupService } from "../../../index";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class MarketTimeReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.MarketTimeConstantImpl>
  implements IMarketTimePromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.MarketTimeConstantImpl,
      "MarketTimeConstantImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new MarketTimeLookupService(),
    );
  }

  getMarketTime(id: string): Promise<CubiqTS.MarketTimeConstantImpl> {
    let request = new UiArguments("getMarketTime");
    let arg1 = new FnArg(id, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getAllMarketTime(): Promise<Array<string>> {
    let request = new UiArguments("getAllMarketTime");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
